import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux"; // Import useDispatch from react-redux
import { CgCalendarDates } from "react-icons/cg";
import { IoMdTime } from "react-icons/io";
import DatePicker from "react-datepicker";
import axios from "axios";
import "react-datepicker/dist/react-datepicker.css";
import { BsFillArrowRightCircleFill } from "react-icons/bs";
import "./ChatInfo.css";
const allowedCountries = ["NG", "KE", "ET"];

const ChatInfo = ({ control, register, errors }) => {
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const dispatch = useDispatch();

  // Fetch states on component mount
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get(
          `https://countriesnow.space/api/v0.1/countries/`
        );
        const filteredCountries = response.data.data.filter((country) =>
          allowedCountries.includes(country.iso2)
        );
        setCountries(filteredCountries);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCountries();
  }, []);

  // Fetch states when a country is selected
  useEffect(() => {
    const fetchStates = async () => {
      if (!selectedCountry) return;
      try {
        const response = await axios.post(
          `https://countriesnow.space/api/v0.1/countries/states`,
          {
            country: selectedCountry,
          }
        );
        setStates(response.data.data.states);
      } catch (error) {
        console.error("Error fetching states:", error);
      }
    };

    fetchStates();
  }, [selectedCountry]);

  // Fetch cities when a state is selected
  useEffect(() => {
    const fetchCities = async () => {
      if (!selectedState) return;
      try {
        const response = await axios.post(
          `https://countriesnow.space/api/v0.1/countries/state/cities`,
          {
            country: selectedCountry,
            state: selectedState,
          }
        );
        setCities(response.data.data);
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    };

    fetchCities();
  }, [selectedState]);

  const excludeWeekends = (date) => {
    const day = date.getDay();
    return day !== 0 && day !== 6;
  };

  const generateTimeOptions = () => {
    const timeOptions = [];
    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += 30) {
        const hourString = String(hour).padStart(2, "0");
        const minuteString = String(minute).padStart(2, "0");
        const amPm = hour < 12 ? "AM" : "PM";
        const hour12 = hour === 0 ? 12 : hour <= 12 ? hour : hour - 12;
        timeOptions.push(`${hour12}:${minuteString} ${amPm}`);
      }
    }
    return timeOptions;
  };
  const timeOptions = generateTimeOptions();

  return (
    <div className="container">
      <div className="content-box">
        <div>
          <div className="w-full">
            <div className="w-full  mb-4">
              <label className="mb-4" htmlFor="hospitalName">
                Hospital Name
              </label>
              <input
                {...register("hospital")}
                type="text"
                name="hospital"
                className="hInput mt-2"
                placeholder='e.g "Lagos University Teaching Hospital"'
              />
              <p>
                {errors.hospital && (
                  <span className="error">{errors.hospital.message}</span>
                )}
              </p>
            </div>
          </div>

          <div className="w-full flex lg:flex-row  gap-2 mb-2">
            <div className=" w-6/12  mb-2">
              <label className="city-label mb-2 mt-2" htmlFor="city">
                Country
              </label>
              <select
                {...register("country", { required: "Country is required" })}
                name="country"
                className="hInput mt-2"
                onChange={(e) => {
                  setSelectedCountry(e.target.value);
                  setSelectedState(""); // Reset state selection when country changes
                  setCities([]); // Reset cities when country changes
                }}
              >
                <option value="">Select Country</option>
                {countries.map((country, index) => (
                  <option key={index} value={country.country}>
                    {country.country}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="w-full flex lg:flex-row  gap-2 mb-2 mt-2">
            <div className=" w-6/12  mb-2">
              <label
                className="lg:ml-auto lg:mr-10 city-label mb-2 mt-2"
                htmlFor="city"
              >
                State of Operation
              </label>
              <select
                {...register("state", { required: "State is required" })}
                name="state"
                className="hInput mt-2"
                onChange={(e) => setSelectedState(e.target.value)}
                disabled={!selectedCountry} // Disable if no country is selected
              >
                <option value="">Select State</option>
                {selectedCountry === "Nigeria" && (
                  <option value="Federal Capital Territory">Abuja</option>
                )}
                {states
                  .filter((state) => state.state_code !== "NG-FC")
                  .map((state, index) => {
                    const stateName =
                      state.name === "Federal Capital Territory"
                        ? "Abuja"
                        : state.name;
                    return (
                      <option key={index} value={stateName}>
                        {stateName}
                      </option>
                    );
                  })}
              </select>
              {/* <input
                {...register("state")}
                type="text"
                name="state"
                className="lg:w-full  mt-2 mb-2 lg:ml-auto md:w-full p-2 border border-gray-300 rounded-lg cityInput"
                placeholder='e.g "Lagos"'
              /> */}

              <p>
                {errors.state && (
                  <span className="error">{errors.state.message}</span>
                )}
              </p>
            </div>
            <div className="w-6/12  mb-2">
              <label className="lg:ml-auto lg:mr-10 city-label" htmlFor="city">
                City of Operation
              </label>
              <select
                {...register("city", { required: "City is required" })}
                name="city"
                className="hInput mt-2"
                disabled={!selectedState} // Disable if no state is selected
              >
                <option value="">Select City</option>
                {cities.map((city, index) => (
                  <option key={index} value={city}>
                    {city}
                  </option>
                ))}
              </select>
              {/* <input
                {...register("city")}
                type="text"
                name="city"
                className="lg:w-full mt-2 mb-2 lg:ml-auto md:w-full p-2 border border-gray-300 rounded-lg cityInput"
                placeholder='e.g "Ojota"'
              /> */}

              <p>
                {errors.city && (
                  <span className="error">{errors.city.message}</span>
                )}
              </p>
            </div>
          </div>

          <div className="input-group1">
            <label>
              <input
                {...register("checked")}
                type="checkbox"
                name="checked"
                className="checkbox"
              />{" "}
              I currently work here
            </label>
          </div>

          <div className="flex items-center gap-4 w-full">
            <div className="appoint-date">
              <label className="date-label" htmlFor="appointmentDate">
                Appointment date
              </label>
              <div>
                <Controller
                  control={control}
                  name="date"
                  render={({ field }) => (
                    <DatePicker
                      placeholderText="Select date"
                      onChange={(date) => field.onChange(date)}
                      selected={field.value}
                      autoFocus={false}
                      className="date-input"
                      dateFormat="dd-MM-yyyy"
                      minDate={new Date()}
                      filterDate={excludeWeekends}
                    />
                  )}
                />
                <div className="input-date-icon">
                  <CgCalendarDates />
                </div>
              </div>

              <p>
                {errors.date && (
                  <span className="error">{errors.date.message}</span>
                )}
              </p>
            </div>
            <div className="appoint-time">
              <label className="time-label" htmlFor="appointmentTime">
                Time
              </label>

              <select
                {...register("time")}
                name="time"
                className="bg-white time-input"
              >
                <option value="">Select</option>
                {timeOptions.map((timeOption) => (
                  <option key={timeOption} value={timeOption}>
                    {timeOption}
                  </option>
                ))}
              </select>
              <div className="input-time-icon">
                <IoMdTime />
              </div>

              <p>
                {errors.time && (
                  <span className="error">{errors.time.message}</span>
                )}
              </p>
            </div>
            <div className="mode-group">
              <label className="mode-label" htmlFor="preferredMode">
                Preferred Mode
              </label>
              <select
                {...register("mode")}
                name="mode"
                className="select-label"
              >
                <option value="">Select</option>
                <option value="virtualMeeting">Virtual Meeting</option>
                <option value="PhysicalMeeting">In Person</option>
              </select>

              <p>
                {errors.mode && (
                  <span className="error">{errors.mode.message}</span>
                )}
              </p>
            </div>
          </div>
          <div className="horizontal-line"></div>

          {/* Add functionality to other labels and inputs */}
          <div className="supplies">
            <label htmlFor="supplies" className="supply-label">
              Which Supplies are you in charge of procuring?
            </label>
            <select
              {...register("supplies")}
              name="supplies"
              className="select-supply"
            >
              <option value="">Select</option>
              <option value="blood">Blood</option>
              <option value="oxygen">Oxygen</option>
              <option value="medicine">Medical consumables</option>
              <option value="equipment">Equipment</option>
              <option value="procureAll">Procure All</option>
            </select>

            <p>
              {errors.supplies && (
                <span className="error">{errors.supplies.message}</span>
              )}
            </p>
          </div>

          <div className="procure">
            <label htmlFor="procure" className="procure-label">
              How often do you procure?
            </label>
            <select
              {...register("frequency")}
              name="frequency"
              className="procure-supply"
            >
              <option value="">Select</option>
              <option value="monthly">Monthly</option>
              <option value="weekly">Weekly</option>
              <option value="anytime">Just any time</option>
            </select>

            <p>
              {errors.frequency && (
                <span className="error">{errors.frequency.message}</span>
              )}
            </p>
          </div>

          <div className="spend">
            <label htmlFor="spend" className="spend-label">
              How much do you typically spend on all supplies when you order
              supplies?
            </label>
            <div className="relative">
              <select
                {...register("currency")}
                name="currency"
                className="absolute w-10 bg-white outline-none inset-y-0 left-0 pt-1 border border-gray-300 rounded-lg "
              >
                <option value="₦">₦</option>
                <option value="(KES)">KES</option>
                <option value="ETB">ETB</option>
              </select>
              <input
                {...register("amounts")}
                type="number"
                name="amounts"
                className="pl-10 outline-none w-full p-3 border border-gray-300 rounded-lg "
              />

              <p>
                {errors.amounts && (
                  <span className="error">{errors.amounts.message}</span>
                )}
              </p>
            </div>
          </div>

          <div className="important">
            <label htmlFor="important" className="impor-label">
              What value is most important to you?
            </label>
            <select
              {...register("value")}
              name="value"
              className="impor-supply"
            >
              <option value="">Select</option>
              <option value="fast">Fast Deliveries</option>
              <option value="save">Safe Supplies</option>
              <option value="reliable">Reliable Service</option>
              <option value="all">All of the above</option>
            </select>

            <p>
              {errors.value && (
                <span className="error">{errors.value.message}</span>
              )}
            </p>
          </div>

          <div className="chat">
            <label htmlFor="chat" className="chat-label">
              What's the one thing you would change about your current
              suppliers?
            </label>
            <textarea
              {...register("feedback")}
              type="text"
              name="feedback"
              className="chat-input"
            />

            <p>
              {errors.feedback && (
                <span className="error">{errors.feedback.message}</span>
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatInfo;
